"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var scenario_actions_1 = __importDefault(require("../../redux/scenario/scenario.actions"));

var move_next_node_button_component_1 = __importDefault(require("./move-next-node-button.component"));

var scenario_selectors_1 = require("../../redux/scenario/scenario.selectors");

var MoveNextNodeButtonContainer = function MoveNextNodeButtonContainer(_ref) {
  var nextNodeId = _ref.nextNodeId;
  var dispatch = react_redux_1.useDispatch();
  var node = react_redux_1.useSelector(scenario_selectors_1.getSelectNode(nextNodeId));

  if (!node) {
    console.error("node with given id does not exist @MoveNextNodeButtonContainer!!! id >>> ".concat(nextNodeId));
    return null;
  }

  return react_1.default.createElement(move_next_node_button_component_1.default, {
    type: node.type,
    onClick: function onClick() {
      return dispatch(scenario_actions_1.default.moveNode({
        nextNodeId: nextNodeId
      }));
    }
  });
};

exports.default = MoveNextNodeButtonContainer;